import { ClockCircleFilled, LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, message, notification, Row, Select, Typography, Upload } from "antd";
import { useEffect, useState } from "react";
import { read as XLSXread, utils as XLSXutils } from "xlsx";
import ImageSucces from "../../asset/modal/successModal.gif";
import { ContentBox } from "../../components/layout/content";
import { LoginedLayout } from "../../components/layout/loginLayout";
import { GET, PATCH } from "../../services";
import { CHECK_UPLOAD_ORDER, CONSTANT_BRAND_2, CONSTANT_PLATFORM } from "../../services/path";
import UploadAlert from "./view/UploadAlert";
import UploadNotAlert from "./view/UploadNotAlert";

const { Option } = Select;
const { Title, Text } = Typography;

interface Platform {
  platf_id: number;
  platf_name: string;
}

interface Brand {
  platf_id: number;
  platf_name: string;
  brand_id: number;
  brand_name: string;
  shop_id: string;
}

const RecheckOrder = () => {
  const [form3] = Form.useForm();
  const [platfromRecheck, setPlatfromRecheck] = useState<Platform[]>([]);
  const [brands, setBrands] = useState<Brand[]>([]);
  const [filteredBrands, setFilteredBrands] = useState<Brand[]>([]);
  const [selectedPlatfId, setSelectedPlatfId] = useState<number | null>(null);
  const [selectedPlatfName, setSelectedPlatfName] = useState<string | null>(null);
  const [selectedShopId, setSelectedShopId] = useState<string | null>(null);
  const [selectedBrandName, setSelectedBrandName] = useState<string | null>(null);
  const [orders, setOrders] = useState<string[]>([]);
  const [diffOrders, setDiffOrders] = useState<string[]>([]);
  const [isHaveModalVisible, setHaveOrderMoadlVisible] = useState<boolean>(false);
  const [isNotModalVisible, setNotOrderMoadlVisible] = useState<boolean>(false);
  const [isLoadingUpload, setIsLoadingUpload] = useState<boolean>(false);
  const [remainingTime, setRemainingTime] = useState<number>(
    parseInt(localStorage.getItem("remainingTime") || "0"),
  );

  const [isPreImage, setPreImage] = useState<string | null>(null);
  const [uploadTime, setUploadTime] = useState<string | null>(null);
  const [fileList, setFileList] = useState<any[]>([]);
  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const data = await GET(CONSTANT_PLATFORM);
        if (!data) {
          throw new Error("Failed to fetch platforms");
        }

        const filteredPlatforms = data.filter((platform: { platf_id: number }) =>
          [4, 8, 9].includes(platform.platf_id),
        );

        setPlatfromRecheck(filteredPlatforms);
      } catch (error) {
        console.error("Error fetching platforms:", error);
      }
    };

    fetchPlatforms();
  }, []);

  useEffect(() => {
    const fetchBrandName = async () => {
      try {
        const data = await GET(CONSTANT_BRAND_2);
        if (!data) {
          throw new Error("Fail to fetch brand name");
        }

        setBrands(data);
        setFilteredBrands(data);
      } catch (error) {
        console.error("Error fetching platforms:", error);
      }
    };

    fetchBrandName();
  }, []);

  useEffect(() => {
    const img = new Image();
    img.src = ImageSucces;
    img.onload = () => {
      setPreImage(ImageSucces);
    };
  }, []);

  useEffect(() => {
    const savedRemainingTime = parseInt(localStorage.getItem("remainingTime") || "0");
    const savedTimestamp = parseInt(localStorage.getItem("timestamp") || "0");
    const currentTime = Math.floor(Date.now() / 1000);

    // case: ถ้าผลต่างเวลา Time stamp
    if (savedRemainingTime > 0 && currentTime - savedTimestamp >= savedRemainingTime) {
      setRemainingTime(0);
      localStorage.removeItem("remainingTime");
      localStorage.removeItem("timestamp");
    } else if (savedRemainingTime > 0) {
      setRemainingTime(savedRemainingTime - (currentTime - savedTimestamp));
    }

    // case: normal
    if (remainingTime > 0) {
      const timerId = setInterval(() => {
        setRemainingTime((prevTime: number) => {
          if (prevTime > 0) {
            const newTime = prevTime - 1;
            localStorage.setItem("remainingTime", newTime.toString());
            localStorage.setItem("timestamp", Math.floor(Date.now() / 1000).toString());
            return newTime;
          } else {
            clearInterval(timerId);
            localStorage.removeItem("remainingTime");
            localStorage.removeItem("timestamp");
            return 0;
          }
        });
      }, 1000);

      return () => clearInterval(timerId);
    }
  }, [remainingTime]);

  const formatTime = (totalTimeInSeconds: number) => {
    const days = Math.floor(totalTimeInSeconds / (3600 * 24));
    const hours = Math.floor((totalTimeInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalTimeInSeconds % 3600) / 60);
    const seconds = totalTimeInSeconds % 60;
    return { days, hours, minutes, seconds };
  };

  const { days, hours, minutes, seconds } = formatTime(remainingTime);
  const displayTime = () => {
    const timeUnits = [
      days > 0 ? `${days} days` : "",
      hours > 0 ? `${hours} hours` : "",
      minutes > 0 ? `${minutes} minutes` : "",
      seconds > 0 ? `${seconds} seconds` : "",
    ];

    return timeUnits.filter((unit) => unit !== "").join(" ");
  };

  const handleSearchBrand = (value: string) => {
    const filtered = brands.filter((brand) =>
      brand.brand_name.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredBrands(filtered);
  };

  const handleSelectPlatform = (value: string) => {
    const filtered = brands.filter(
      (brand) =>
        brand.brand_name.toLowerCase().includes(value.toLowerCase()) &&
        brand.platf_id === selectedPlatfId,
    );

    setFilteredBrands(filtered);
  };

  const handlePlatformChange = (value: number, option: any) => {
    setSelectedPlatfId(value);
    setSelectedPlatfName(option.children);
    setSelectedBrandName(null);
    setSelectedShopId(null);
    form3.resetFields(["store"]);
    const filtered = brands.filter((brand) => brand.platf_id === value);
    setFilteredBrands(filtered);
  };

  const handleBrandChange = (value: number, option: any) => {
    const selectedBrand = brands.find(
      (brand) => brand.brand_id === value && brand.platf_id === selectedPlatfId,
    );

    if (selectedBrand) {
      setSelectedBrandName(option.children);
      setSelectedShopId(selectedBrand.shop_id);
    }
  };

  const handleClearPlatform = () => {
    setSelectedPlatfId(null);
    setSelectedPlatfName(null);
    setFilteredBrands(brands);
    setSelectedBrandName(null);
    setSelectedShopId(null);
    form3.resetFields(["platform", "store"]);
  };

  const handleClearBrand = () => {
    setSelectedBrandName(null);
    setSelectedShopId(null);
    setFilteredBrands(brands);
    form3.resetFields(["store"]);
    if (selectedPlatfId) {
      setFilteredBrands(brands.filter((brand) => brand.platf_id === selectedPlatfId));
    }
  };

  const handleFileUpload = (file: File, platf_id: number, brand: string, shop_id: string) => {
    if (!file) {
      notification.error({
        message: "File Error",
        description: "กรุณาเลือกไฟล์ให้ถูกต้อง",
      });

      return false;
    }

    setIsLoadingUpload(true);
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target?.result;
      if (typeof data !== "string") {
        setIsLoadingUpload(false);
        return;
      }

      const workbook = XLSXread(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rawData = XLSXutils.sheet_to_json(worksheet, { header: 1 }) as any[][];
      processExcelData(rawData, platf_id, brand);
    };

    reader.readAsBinaryString(file);
    return false; // To prevent automatic upload
  };

  const processExcelData = async (rawData: any[][], platf_id: number, brand: string) => {
    let orderNumberIndex: any;
    const ordersSet = new Set<string>();
    let extractedOrderNumbers: string[] = [];
    const duplicateOrderNumbers: string[] = [];

    if (platf_id === 4) {
      orderNumberIndex = rawData[0].indexOf("orderNumber");
    } else if (platf_id === 8) {
      // Define logic for the new flow based on platf_id
      orderNumberIndex = rawData[0].indexOf("หมายเลขคำสั่งซื้อ"); // Example column name for new flow
    } else if (platf_id === 9) {
      // Define logic for the new flow based on platf_id
      orderNumberIndex = rawData[0].indexOf("Order ID"); // Example column name for new flow
    } else {
      notification.error({
        message: "Incorrect platfrom value",
        description: "กรุณาเลือก platform ให้ถูกต้อง",
      });
    }

    if (orderNumberIndex === -1) {
      console.error('Column "orderNumber" not found in the uploaded file.');
      notification.error({
        message: "Upload Error",
        description: 'Column "orderNumber" not found in the uploaded file.',
      });

      return;
    }

    extractedOrderNumbers = rawData
      .slice(1)
      .filter((row) => {
        const orderNumber = row[orderNumberIndex]?.toString() || "";
        if (platf_id === 9) {
          return /^[0-9]+$/.test(orderNumber); // Include only numeric order numbers for TikTok
        }

        return true; // Include all order numbers for other platforms
      })
      .map((row) => row[orderNumberIndex]?.toString() || "")
      .filter((orderNumber) => {
        if (ordersSet.has(orderNumber)) {
          duplicateOrderNumbers.push(orderNumber); // Collect duplicate order numbers
          return false; // Exclude duplicate order numbers
        }

        ordersSet.add(orderNumber);
        return true; // Include unique order numbers
      });

    setOrders(extractedOrderNumbers);
    const checkOrderResponse = await handleCheckOrder(extractedOrderNumbers, platf_id, brand);
    setDiffOrders(checkOrderResponse);
    setIsLoadingUpload(false);
    if (checkOrderResponse && checkOrderResponse.length > 0) {
      // when orders have different
      setHaveOrderMoadlVisible(true);
    } else {
      // when orders don't have different
      setNotOrderMoadlVisible(true);
    }

    localStorage.setItem("remainingTime", (checkOrderResponse.length * 4).toString());
    localStorage.setItem("timestamp", Math.floor(Date.now() / 1000).toString());
    setRemainingTime(checkOrderResponse.length * 4);
    setUploadTime(new Date().toLocaleString()); // Set the upload time
  };

  const clearResultsUpload = () => {
    setOrders([]);
    setDiffOrders([]);
    setFileList([]);
    localStorage.removeItem("remainingTime");
    localStorage.removeItem("timestamp");
  };

  const copyOrderToClipboard = () => {
    const ordersJson = JSON.stringify(orders, null, 2);
    navigator.clipboard
      .writeText(ordersJson)
      .then(() => {
        message.success("Order numbers copied to clipboard!");
      })
      .catch((err) => {
        message.error("Failed to copy order numbers to clipboard.");
        console.error("Could not copy text: ", err);
      });
  };

  const handleCheckOrder = async (orders: string[], platf_id: number, brand: string) => {
    try {
      const requestBody = {
        BrandName: brand,
        PlatfID: platf_id,
        ListOrder: orders, // Include extracted order numbers
      };

      const result = await PATCH(CHECK_UPLOAD_ORDER, requestBody);
      return result || [];
    } catch (error) {
      console.error("Error checking orders:", error);
      message.error("An error occurred while checking orders");
      return [];
    }
  };

  return (
    <LoginedLayout>
      <ContentBox style={{ marginTop: "5vh" }}>
        <Title level={2} style={{ marginBottom: "8px" }}>
          Recheck Order
        </Title>
        <Form form={form3} layout="vertical">
          <Row gutter={[56, 14]} justify="start" align="middle" style={{ marginBottom: "5px" }}>
            <Col span={12}>
              <Form.Item
                name="platform"
                label="Select Platform:"
                rules={[{ required: true, message: "Please select a platform" }]}
              >
                <Select
                  showSearch
                  placeholder="Select a platform"
                  filterOption={false} // Disable default filtering
                  onSearch={handleSelectPlatform}
                  notFoundContent={null}
                  allowClear
                  onClear={handleClearPlatform} // Reset to filtered list when cleared
                  onChange={handlePlatformChange}
                >
                  {platfromRecheck.map((platform) => (
                    <Option key={platform.platf_id} value={platform.platf_id}>
                      {platform.platf_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="store"
                label="Select store:"
                rules={[{ required: true, message: "Please select a Brand" }]}
              >
                <Select
                  showSearch
                  placeholder="Select a brand"
                  filterOption={false} // Disable default filtering
                  onSearch={handleSearchBrand}
                  notFoundContent={null}
                  allowClear
                  onClear={handleClearBrand} // Reset to full list when cleared
                  onChange={handleBrandChange}
                >
                  {filteredBrands.map((brand) => (
                    <Option key={brand.brand_id} value={brand.brand_id}>
                      {brand.brand_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="upload"
            label={<Text strong>Upload: </Text>}
            rules={[{ required: true, message: "Please upload an invoice" }]}
          >
            <Upload
              accept=".xlsx, .xls"
              fileList={fileList}
              beforeUpload={(file) => {
                if (
                  selectedPlatfId !== null &&
                  selectedBrandName !== null &&
                  selectedShopId !== null
                ) {
                  setFileList([file]);
                  return handleFileUpload(file, selectedPlatfId, selectedBrandName, selectedShopId);
                } else {
                  message.error("Please select both Platform and Brand before uploading.");
                  return false;
                }
              }}
              onRemove={() => {
                setFileList([]);
                clearResultsUpload();
              }}
              showUploadList={false}
            >
              <Button
                icon={isLoadingUpload ? <LoadingOutlined /> : <UploadOutlined />}
                loading={isLoadingUpload}
                style={{ backgroundColor: "#4CAF50", borderColor: "#4CAF50", color: "white" }} // Original green
              >
                {isLoadingUpload ? "Uploading..." : "Upload invoice"}
              </Button>
            </Upload>
          </Form.Item>
        </Form>
        <UploadAlert
          open={isHaveModalVisible}
          onCancel={() => setHaveOrderMoadlVisible(false)}
          order_no={orders}
          diff_order_no={diffOrders}
          platfrom={selectedPlatfName ?? "Unknown Platform"}
          brand={selectedBrandName ?? "Unknown Brand"}
          platfrom_id={selectedPlatfId ?? 0}
          shop_id={selectedShopId ?? "Unknown shop_id"}
          uploadTime={uploadTime ?? "Unknown time"}
        />
        <UploadNotAlert
          open={isNotModalVisible}
          onCancel={() => setNotOrderMoadlVisible(false)}
          order_no={orders}
          diff_order_no={diffOrders}
          platfrom={selectedPlatfName ?? "Unknown Platform"}
          brand={selectedBrandName ?? "Unknown Brand"}
          platfrom_id={selectedPlatfId ?? 0}
          shop_id={selectedShopId ?? "Unknown shop_id"}
          preImage={isPreImage ?? "Unknown image"}
          timeUsed={diffOrders.length}
          uploadTime={uploadTime ?? "Unknown time"}
        />
      </ContentBox>
      {diffOrders.length > 0 && (
        <ContentBox style={{ marginTop: "2vh" }}>
          <Form form={form3}>
            <Form.Item>
              <div>
                <Row
                  gutter={[56, 24]}
                  justify="start"
                  align="middle"
                  style={{ marginBottom: "20px" }}
                >
                  <Col>
                    <Text strong style={{ fontSize: "18px", color: "#656565" }}>
                      Platform: {selectedPlatfName}
                    </Text>
                  </Col>
                  <Col>
                    <Text strong style={{ fontSize: "18px", color: "#656565", marginLeft: "10px" }}>
                      Brand: {selectedBrandName}
                    </Text>
                  </Col>
                  <Col>
                    <Text strong style={{ fontSize: "18px", color: "#656565", marginLeft: "10px" }}>
                      จำนวนที่ขาด: {diffOrders.length}
                    </Text>
                  </Col>
                  <Col>
                    <Text strong style={{ fontSize: "18px", color: "#656565", marginLeft: "10px" }}>
                      Time: <ClockCircleFilled style={{ color: "#faad14", marginRight: "4px" }} />{" "}
                      {displayTime()}
                    </Text>
                  </Col>
                </Row>
                <Button type="default" onClick={clearResultsUpload} style={{ marginRight: 10 }}>
                  Clear Results
                </Button>
                <Button type="primary" onClick={copyOrderToClipboard}>
                  Copy
                </Button>
                <pre
                  style={{
                    marginTop: "20px",
                    textAlign: "left",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  {JSON.stringify(diffOrders, null, 2)}
                </pre>
              </div>
            </Form.Item>
          </Form>
        </ContentBox>
      )}
    </LoginedLayout>
  );
};

export default RecheckOrder;
